<template>
  <div class="something-else">
    <textarea
      ref="box"
      :value="modelValue"
      :aria-label="label"
      :maxlength="maxLength"
      rows="1"
      placeholder="Say it in your own words"
      @input="onInput"
      @keydown.enter.exact.prevent="$emit('send')"
    ></textarea>
    <button
      v-if="sendable"
      type="button"
      class="something-else__send"
      :disabled="!modelValue.trim()"
      @click="$emit('send')"
    >
      Send
    </button>
  </div>
</template>

<script>
import { OTHER_MAX } from "@/components/OliverBotV2/interactions/answers";

export default {
  name: "SomethingElse",
  props: {
    modelValue: { type: String, default: "" },
    label: { type: String, required: true },
    /** These words alone answer the card, so they carry their own Send. */
    sendable: { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "send"],
  data() {
    return { maxLength: OTHER_MAX };
  },
  mounted() {
    this.$refs.box.focus();
    this.fit();
  },
  methods: {
    onInput(event) {
      this.$emit("update:modelValue", event.target.value);
      this.fit();
    },
    /** Grow with the words, up to the box's max-height. */
    fit() {
      const box = this.$refs.box;
      box.style.height = "auto";
      box.style.height = `${
        box.scrollHeight + box.offsetHeight - box.clientHeight
      }px`;
    },
  },
};
</script>

<style lang="scss" scoped>
.something-else {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 8px;

  textarea {
    flex: 1 1 200px;
    box-sizing: border-box;
    min-width: 0;
    min-height: 44px;
    max-height: 104px;
    padding: 11px 10px;
    border: 1px solid var(--oliver-input-border);
    border-radius: 8px;
    background: var(--oliver-input-bg);
    color: var(--oliver-text);
    font: inherit;
    font-size: 13px;
    line-height: 1.5;
    resize: none;
    overflow-y: auto;

    &:focus {
      outline: none;
      border-color: var(--oliver-input-focus-border);
    }
  }
}

.something-else__send {
  flex: 0 0 auto;
  min-height: 44px;
  padding: 7px 14px;
  border: none;
  border-radius: 8px;
  background: var(--oliver-accent);
  color: #fff;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>
